// App.js
import React, { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Project from "./components/Project";
function App() {
  useEffect(() => {
    document.title = "Glorious Home Decor";
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Project />} />
        <Route path="/:id" element={<Project />} />
      </Routes>
    </Router>
  );
}

export default App;
